import { render, staticRenderFns } from "./ApexDataAreaChart.vue?vue&type=template&id=04c0edd8&"
import script from "./ApexDataAreaChart.vue?vue&type=script&lang=js&"
export * from "./ApexDataAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexDataAreaChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports